import { Outlet, useLocation } from 'react-router-dom';
import React, { useContext, useEffect, useState } from 'react';
import { Footer } from '../components/Footer';
import { Navbar } from '../components/Navbar';
import { StyledColumnBox, StyledLayout, StyledRowBox } from '../theme/StyledElements';
import { Sidebar } from '../components/Sidebar';
import { UserContext } from '../providers/UserProvider';
import { BasketListViewModel } from '../models/BasketListViewModel';
import { SidebarList } from '../models/SidebarList';
import { getUndeletedBaskets } from '../services/cloudFirestore';
import { getBasketNames } from '../utils';
import { Add } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { FarmSidebar } from '../components/FarmSidebar';
import { useMountedRef } from '../hooks/useMountedRef';
import { Box } from '@mui/material';
import { useGlobalState } from '../providers/GlobalStateProvider';

export function DashboardLayout(): React.ReactElement {
    const { t } = useTranslation();
    const mounted = useMountedRef();
    const { pathname } = useLocation();
    const { setState, state } = useGlobalState();
    const user = useContext(UserContext);
    const [paniersList, setPaniersList] = useState<BasketListViewModel[]>([]);
    const [menu, setMenuList] = useState<SidebarList[]>([]);
    const [active, setActive] = useState<string>('id');
    const [path, setPath] = useState<string>('');

    useEffect(() => {
        if (state.baskets) {
            const basketList = getBasketNames(state.baskets);
            setPaniersList(basketList);
            if (basketList[basketList.length - 1]) {
                setActive(basketList[basketList.length - 1].id);
            }
        }
    }, [state]);

    useEffect(() => {
        if (pathname) {
            setPath(pathname.split('/')[1]);
        }
    }, [pathname]);

    useEffect(() => {
        if (user && user.idProducteur && mounted.current) {
            getUndeletedBaskets(user.idProducteur).then((data) => {
                if (data && mounted.current) {
                    setState((prev) => ({
                        ...prev,
                        baskets: data
                    }));
                    const basketList = getBasketNames(data);
                    setPaniersList(basketList);
                    if (basketList[0] && mounted.current) {
                        setActive(basketList[0].id);
                    }
                }
            });
        }
    }, []);

    useEffect(() => {
        if (paniersList || active || path) {
            setMenuList([
                {
                    icon: <Add sx={{ color: '#E37F1E' }} />,
                    title: t('addBasket'),
                    color: '#E37F1E',
                    path: '/add-basket'
                },
                {
                    title: t('myBaskets'),
                    items: path === 'add-basket' || path === 'push-message' ? [] : paniersList,
                    color: path === 'add-basket' || path === 'push-message' ? '#394A35' : '#FFFFFF',
                    path: `/view-basket/${active}`
                },
                {
                    title: t('myCurrentMessage'),
                    color: '#394A35',
                    path: '/push-message'
                }
            ]);
        }
    }, [paniersList, active, path]);

    return (
        <StyledLayout>
            <Box>
                {path === 'push-message' && (
                    <>
                        <Navbar activeStep={1} id={active} />
                        <StyledRowBox>
                            <StyledColumnBox>
                                <Sidebar
                                    menu={menu}
                                    active={active}
                                    setActive={setActive}
                                    path={path}
                                />
                            </StyledColumnBox>
                            <Outlet />
                        </StyledRowBox>
                    </>
                )}
                {path === 'add-basket' && (
                    <>
                        <Navbar activeStep={1} id={active} />
                        <StyledRowBox>
                            <StyledColumnBox>
                                <Sidebar
                                    menu={menu}
                                    active={active}
                                    setActive={setActive}
                                    path={path}
                                />
                            </StyledColumnBox>
                            <Outlet />
                        </StyledRowBox>
                    </>
                )}
                {path === 'view-basket' && (
                    <>
                        <Navbar activeStep={1} id={active} />
                        <StyledRowBox>
                            <StyledColumnBox>
                                <Sidebar
                                    menu={menu}
                                    active={active}
                                    setActive={setActive}
                                    path={path}
                                />
                            </StyledColumnBox>
                            <Outlet />
                        </StyledRowBox>
                    </>
                )}
                {(path === 'dashboard' || path === '') && (
                    <>
                        <Navbar activeStep={0} id={active} />
                        <Outlet />
                    </>
                )}
                {path === 'view-farm' && (
                    <>
                        <Navbar activeStep={2} id={active} />
                        <StyledRowBox>
                            <StyledColumnBox>
                                <FarmSidebar active={0} />
                            </StyledColumnBox>
                            <Outlet />
                        </StyledRowBox>
                    </>
                )}
                {path === 'modify-farm' && (
                    <>
                        <Navbar activeStep={2} id={active} />
                        <StyledRowBox>
                            <StyledColumnBox>
                                <FarmSidebar active={0} />
                            </StyledColumnBox>
                            <Outlet />
                        </StyledRowBox>
                    </>
                )}
                {path === 'clients' && (
                    <>
                        <Navbar activeStep={2} id={active} />
                        <StyledRowBox>
                            <StyledColumnBox>
                                <FarmSidebar active={3} />
                            </StyledColumnBox>
                            <Outlet />
                        </StyledRowBox>
                    </>
                )}
                {path === 'collection' && (
                    <>
                        <Navbar activeStep={2} id={active} />
                        <StyledRowBox>
                            <StyledColumnBox>
                                <FarmSidebar active={1} />
                            </StyledColumnBox>
                            <Outlet />
                        </StyledRowBox>
                    </>
                )}
            </Box>
            <Footer />
        </StyledLayout>
    );
}
